/*
 * Lib Module Format
 */

Lib.Format = (function() {
    let self = {};

    /**
     *
     * @param dirtypostcode
     * @returns {*}
     */
    self.postcode = function(dirtypostcode) {

        if (typeof dirtypostcode === 'undefined') {
            return;
        }

        let pc = dirtypostcode.replace(' ', '').toUpperCase();

        if (typeof pc === 'string' && pc.length === 6) {
            return pc.substring(0, 4) + ' ' + pc.substring(4, 6);
        }

        return dirtypostcode;
    };

    /**
     * Format url
     *
     * @param url
     * @param full
     * @returns {*}
     */
    self.url = function(url, full) {

        if (typeof url === 'object') {

            let ext;
            if ('extension' in url) {
                ext = url.extension;
                delete url['extension'];
            }
            // If full url, dont make an empty value (empty value will implode to a leading slash)
            let formattedUrl = (full) ? [] : [''];

            // Get dynamic_ids
            let dynamicIds = Lib.Util.getOption('dynamic_ids');

            // If we have dynamic_ids
            if (dynamicIds) {

                // Loop through all dynamic ids
                $.map(dynamicIds, function(urlPrefix, urlKey) {

                    // If this dynamic_id exists in the requested url
                    if (urlKey in url) {
                        // Get the dynamic_id value
                        let urlPrefixValue = url[urlKey];

                        // Delete it from the original array so it doesnt get added later
                        delete url[urlKey];

                        // Only add if the value isnt falsy
                        if (urlPrefixValue) {
                            // Add it to the url with its prefix
                            formattedUrl.push(urlPrefix + urlPrefixValue);
                        }
                    }
                });
            }

            // Add all other lets to the url
            $.map(url, function(v) {
                formattedUrl.push(v);
            });

            // Combine the url with a /
            url = formattedUrl.join('/');
            if (ext) {
                url += '.' + ext;
            }
        }

        // If full url, add the base path
        if (full) {
            url = Lib.Util.getOption('params.base') + url;
        }

        return url;

    };

    /**
     *
     * @param text
     * @param limit
     * @param ellipsis
     * @returns {*}
     */
    self.truncate = function(text, limit, ellipsis) {
        ellipsis = ellipsis || '...';
        limit = limit || 200;
        text = $.trim(text);

        let textHolder = $('<div />');

        if (text.length > limit) {
            textHolder.append($('<span />').attr('data-tooltip', text).text(text.slice(0, limit) + ellipsis));
            return textHolder.html();
        }

        return text;
    };

    /**
     *
     * @param question
     * @param yesno
     * @returns {*}
     */
    self.yesNo = function(question, yesno) {
        yesno = yesno || {0: 'Nee', 1: 'Ja'};
        if (typeof question === 'boolean') {
            return (question === true) ? yesno[1] : yesno[0];
        }

        if (question) {
            return yesno[1];
        }

        return yesno[0];
    };

    /**
     * Format decimal function
     * @param value
     * @param amountOfDecimals
     * @returns {{displayValue: (*|void|string), dbValue: (string)}}
     */
    self.decimal = function(value, amountOfDecimals, decimalSeparator, thousandSeparator) {

        let formattedValue, decimalSplit;

        if (typeof decimalSeparator === 'undefined') {
            decimalSeparator = ',';
        }

        if (typeof thousandSeparator === 'undefined') {
            thousandSeparator = '.';
        }

        value = self.cleanNumber(value);
        amountOfDecimals = amountOfDecimals || 0;

        decimalSplit = value.split('.', 2);

        // If the split was successful, we have 2 items, before and after comma
        if (decimalSplit.length === 2 && amountOfDecimals > 0) {

            // Remove stuff from the decimals so we have the requested amount of decimals
            let decimals = decimalSplit[1].substr(0, amountOfDecimals);

            // Add as many 0's we need
            decimals = Lib.String.padRight(decimals, amountOfDecimals, '0');

            // Combine the before and after decimal
            formattedValue = decimalSplit[0] + ',' + decimals;

        } else {
            // If the split resulted in a single value, that means there are no comma's needed
            if (decimalSplit[0]) {
                if (amountOfDecimals > 0) {
                    decimalSplit[0] = decimalSplit[0] + ',';
                    let len = amountOfDecimals + decimalSplit[0].length;
                    formattedValue = Lib.String.padRight(decimalSplit[0], len, '0');
                } else {
                    formattedValue = decimalSplit[0];
                }
            } else {
                formattedValue = decimalSplit[0];
            }
        }

        // Remove unwanted stuff
        let cleanedDisplay = formattedValue.replace(/[^0-9,-]/g, '');

        // Add dots for readability on big numbers
        let cleanSplit = cleanedDisplay.split(',');
        cleanSplit[0] = cleanSplit[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandSeparator);

        let cleanedDottedDisplay = cleanSplit.join(decimalSeparator);

        // Make the db field use a dot instead of a comma
        let dbValue = cleanedDisplay.replace(decimalSeparator, '.');

        // Return the stuff
        return {displayValue: cleanedDottedDisplay, dbValue: dbValue};
    };

    self.cleanNumber = function(num) {

        // Cast to string
        num = num + '';

        if (num === '') {
            return num;
        }

        if ((num.match(/^-?[0-9]+([0-9.,])*$/) || []).length === 0) {
            return '0';
        }

        let dotPos = num.indexOf('.');
        let commaPos = num.indexOf(',');

        let regexDot = /\./g;
        let regexComma = /,/g;

        if (dotPos !== -1 && commaPos !== -1) {
            let thousands_sep = dotPos < commaPos ? regexDot : regexComma;
            return $.trim(num.replace(thousands_sep, '').replace(regexComma, '.'));
        }

        let dotCount = (num.match(regexDot) || []).length;
        let commaCount = (num.match(regexComma) || []).length;

        if (dotCount > 1 || commaCount > 1) {
            return $.trim(num.replace(regexDot, '').replace(regexComma, ''));
        }

        if (commaCount > 0) {
            return $.trim(num.replace(regexComma, '.'));
        }

        if (num.match(/\.[0-9]{3}$/)) {
            num = $.trim(num.replace(regexDot, ''));
        }

        return num;

    };

    return self;

})();
